import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import TablePagination from "@material-ui/core/TablePagination";
import i18n from "../../core/i18n";
import UserEvent from "../../core/UserEvent";

const useStyles = makeStyles((theme) => ({
    root: {
        fontSize: '1rem',
    },
    caption: {
        fontSize: '1rem',
        color: theme.palette.text.secondary
    }
}));

function DataPagination(props) {
    const classes = useStyles();
    const { pageSize, pageNumber, count, pageSizeOptions, size } = props;

    const handlePageChange = (event, pageNumber) => {
        props.onChangePageNumber && props.onChangePageNumber(new UserEvent({pageNumber}, event));
    };

    const handleRowsPerPageChange = (event) => {
        const pageSize = parseInt(event.target.value, 10);
        props.onChangePageSize && props.onChangePageSize(new UserEvent({pageSize}, event));
    };
    const variant = (size === 'small') ? 'body2' : 'body1';
    const labelRowsPerPage = <Typography variant={variant} component='span' >{`${i18n.translate('Rows per page')}:`}</Typography>;

    return (
        <TablePagination
            component='div'
            classes={classes}
            rowsPerPageOptions={pageSizeOptions}
            count={count}
            rowsPerPage={pageSize}
            page={pageNumber}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            labelRowsPerPage = {labelRowsPerPage}
        />
    );
}


DataPagination.propTypes = {
    pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
    count: PropTypes.number.isRequired,
    pageNumber: PropTypes.number,
    pageSize: PropTypes.number,
    size: PropTypes.oneOf(['small', 'medium']),
    onChangePageNumber: PropTypes.func,
    onChangePageSize: PropTypes.func
};

DataPagination.defaultProps = {
    pageSizeOptions: [5, 10, 15, 20, 25],
    pageNumber: 0,
    pageSize: 15,
    count: 0,
    size: 'medium'
};

export default DataPagination;